var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.6 19",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.4 6.7-5.8-0.8-2.6-5.2c-0.1-0.1-0.2-0.3-0.3-0.3-0.4-0.2-0.8 0-1 0.3l-2.5 5.2-5.7 0.8c-0.2 0-0.3 0.1-0.4 0.2-0.2 0.2-0.2 0.4-0.2 0.6s0.1 0.4 0.2 0.5l4.1 4-1 5.7v0.4c0.1 0.1 0.1 0.2 0.2 0.3s0.2 0.1 0.4 0.1c0.1 0 0.3 0 0.4-0.1l5.1-2.7 5.1 2.7c0.1 0.1 0.3 0.1 0.5 0.1 0.4-0.1 0.7-0.4 0.6-0.8l-1-5.7 4.3-4c0.1-0.1 0.2-0.3 0.2-0.5 0.1-0.3-0.2-0.7-0.6-0.8zm-5.5 4.7 0.8 4.8-4.2-2.2-4.3 2.2 0.8-4.7-3.5-3.4 4.8-0.7 2.2-4.4 2.1 4.3 4.8 0.7-3.5 3.4z"
  })));
}

export default SvgStarOutline;